import { DashboardScreen } from "@/screens";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  walletId: z.string().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
});

export const Route = createFileRoute("/dashboard/")({
  component: DashboardScreen,
  validateSearch: searchSchema,
  loader: () => ({
    crumb: "Dashboard",
  }),
});
